const NotFoundPage: React.FC = () => {
  return <h2>Упс... Похоже вы забрели не туда :)</h2>;
};

export default NotFoundPage;
